import { useReduxState } from 'hooks';

import { CSSProperties } from 'react';

export type StatCategory =
  | 'dark'
  | 'darker'
  | 'default'
  | 'error'
  | 'error-light'
  | 'success'
  | 'success-light'
  | 'warning'
  | 'warning-light';

interface Props {
  ariaLabel?: string;
  category?: StatCategory;
  isLarge?: boolean;
  label?: string;
  labelStyle?: CSSProperties;
  style?: CSSProperties;
  value: number | string;
  valueStyle?: CSSProperties;
}

const StatCount = ({
  ariaLabel,
  category,
  isLarge,
  label,
  labelStyle,
  style,
  value,
  valueStyle
}: Props) => {
  const { theme } = useReduxState();

  const valueBackgroundColor = {
    dark: theme.lightGreyDark,
    darker: theme.lightGreyDarkActive,
    default: theme.lightGrey,
    error: theme.dangerColor,
    'error-light': theme.dangerLightColor,
    success: theme.successColor,
    'success-light': theme.successLightColor,
    warning: theme.warningColor,
    'warning-light': theme.warningLightColor
  }[category || 'default'];

  const valueColor = {
    dark: theme.textColorLight,
    darker: theme.textColorLight,
    default: theme.textColorLight,
    error: theme.dangerTextColor,
    'error-light': theme.dangerLightTextColor,
    success: theme.successTextColor,
    'success-light': theme.successLightTextColor,
    warning: theme.warningTextColor,
    'warning-light': theme.warningLightTextColor
  }[category || 'default'];

  return (
    <div
      className="count"
      style={style}
      {...(ariaLabel ? { 'aria-label': ariaLabel } : {})}
    >
      <div className="value" style={valueStyle}>
        <div className="value-content">{value}</div>
      </div>
      {label ? (
        <div className="label" style={labelStyle}>
          {label}
        </div>
      ) : null}

      <style jsx>{`
        .value {
          display: inline-block;
          margin-right: ${label ? '5px' : '0'};
        }
        .value-content {
          background-color: ${valueBackgroundColor};
          border-radius: 10px;
          color: ${valueColor};
          display: inline-block;
          font-size: ${isLarge ? '1.3rem' : '1.2rem'};
          font-weight: 700;
          line-height: 1;
          padding: ${isLarge ? '4px 7px' : '3px 6px'};
        }
        .label {
          color: ${theme.textColorLighter};
          display: inline-block;
          font-size: ${isLarge ? '1.5rem' : '1.3rem'};
          font-weight: 600;
        }
      `}</style>
    </div>
  );
};

export default StatCount;
